import styled from '@emotion/styled';

const CardContent = styled.div`
    flex: 1 1 auto;
`;

export default CardContent;
